import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { SignIn } from '@phosphor-icons/react/SignIn'
import { useAuth } from '../contexts/AuthContext'
import { useTheme } from '../contexts/ThemeContext.jsx'
import { LOTOS_LOGO_DARK, LOTOS_LOGO_LIGHT } from '../lib/branding.js'

export default function Login() {
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const { login: doLogin } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const fromLoc = location.state?.from
  const redirectTo =
    fromLoc && typeof fromLoc.pathname === 'string'
      ? `${fromLoc.pathname}${fromLoc.search || ''}${fromLoc.hash || ''}`
      : '/'
  const { isDark } = useTheme()
  const logoSrc = isDark ? LOTOS_LOGO_DARK : LOTOS_LOGO_LIGHT

  useEffect(() => {
    if (location.pathname !== '/login') return
    setLogin('')
    setPassword('')
    setError('')
    const u = new URL(window.location.href)
    if (u.searchParams.has('token') || u.searchParams.has('password')) {
      u.searchParams.delete('token')
      u.searchParams.delete('password')
      window.history.replaceState({}, '', u.pathname + u.search + u.hash)
    }
  }, [location.pathname])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    try {
      const ok = await doLogin(login, password)
      if (ok) {
        setPassword('')
        navigate(redirectTo, { replace: true })
      } else {
        setError('Invalid login or password')
      }
    } catch (err) {
      setError(err?.message || 'Connection error')
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="glass-panel w-full max-w-sm p-8">
        <div className="mb-6 flex justify-center">
          <img
            src={logoSrc}
            alt="Lotos"
            className="h-14 w-14 object-contain"
          />
        </div>
        <h1 className="mb-2 text-center text-xl font-semibold text-slate-800">Lotos DashBoard</h1>
        <p className="mb-6 text-center text-sm text-slate-500">Sign in to the dashboard</p>
        <form onSubmit={handleSubmit} className="space-y-4" autoComplete="off">
          <div>
            <label className="mb-1.5 block text-sm font-medium text-slate-600">Login</label>
            <input
              type="text"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              className="input-glass w-full rounded-xl"
              placeholder="login"
              autoComplete="off"
            />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-slate-600">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-glass w-full rounded-xl"
              placeholder="••••••••"
              autoComplete="new-password"
            />
          </div>
          {error && <p className="text-sm text-red-500">{error}</p>}
          <button type="submit" className="btn-glass flex w-full items-center justify-center gap-2 bg-white/30">
            <SignIn className="h-5 w-5" />
            Sign in
          </button>
        </form>
      </div>
    </div>
  )
}
